import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const AsthmaIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path d="M14.2 13.8h-2.5l-1.4-6.3c0-.2-.1-.3-.3-.4-.2-.2-.4-.2-.5-.1L3.7 8.4h-.3c-.3.1-.5.4-.5.8.6 3.5 1.5 7.1 2.6 10.5.1.3.3.5.6.8.2.1.5.2.7.3 1 .2 3.5.2 5.3.2h2c.4 0 .6-.3.6-.6v-5.9c.2-.4-.1-.7-.5-.7z" />
      <path d="M21.1 15.4c.3 0 .5-.1.7-.2.2-.2.3-.4.3-.6v-.1c0-.5-.4-.9-.9-.9s-.9.4-.9.9c0 .3.1.5.2.7.1.1.3.2.6.2z" />
      <path d="M21.1 16.4c-.5 0-.9.4-.9 1 0 .5.4.9.9.9.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7 0-.5-.4-.9-1-.9z" />
      <path d="M21.1 19.3c-.5 0-.9.4-.9 1 0 .5.4.9 1 .9.5 0 .9-.4.9-1 0-.3-.1-.5-.3-.7-.2-.1-.4-.2-.7-.2z" />
      <path d="M18.1 15c-.5 0-.9.4-.9 1 0 .5.4.9.9.9.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7-.1-.5-.5-.9-1-.9z" />
      <path d="M18.1 17.8c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9z" />
      <path d="M3.4 7.6l5.9-1.5-.4-1.5c0-.3-.2-.5-.4-.6s-.5-.2-.8-.1l-3.9.8c-.5.1-.9.7-.8 1.2l.4 1.7z" />
    </IconBase>
  );
};

export default AsthmaIcon;
